const baseTheme = {
  fonts: {
    mono: '"SF Mono", "Roboto Mono", Menlo, monospace',
  },
};

const lightTheme = {
  ...baseTheme,
  colors: {
    background: 'white',
    heading: '#000',
    text: 'rgba(2,5,9,0.7)',
    preFormattedText: 'rgb(245, 247, 249)',
    link: 'rgba(13, 132, 255,0.03)',
    hoverColor: 'rgba(13, 132, 255,0.08)'
  },
};

const darkTheme = {
  ...baseTheme,
  colors: {
    background: '#001933',
    heading: '#fff',
    text: '#fff',
    preFormattedText: '#000',
    link: '#0C77E5',
    hoverColor: 'rgba(13, 132, 255,0.03)',
  },
};

export { lightTheme, darkTheme };
